(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.header = null;
      this.headerBounds = { top: 0, bottom: 0 };
      this.headerIsAlwaysSticky = false;
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.preventHide = false;
      this.predictiveSearch = null;
      this.disclosures = null;
      this.searchModal = null;
      this.isScrolling = null;
      this.headerObserver = null;

      this.onScrollHandler = this.onScroll.bind(this);
      this.onViewportChangeHandler = this.setHeaderHeight.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');

      if (!this.header) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.preventHide = this.hasAttribute('data-prevent-hide');
      this.predictiveSearch = this.querySelector('predictive-search');
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

      this.setHeaderHeight();

      this.viewportMediaQuery = window.matchMedia('(max-width: 990px)');

      if (typeof this.viewportMediaQuery.addEventListener === 'function') {
        this.viewportMediaQuery.addEventListener('change', this.onViewportChangeHandler);
      } else if (typeof this.viewportMediaQuery.addListener === 'function') {
        this.viewportMediaQuery.addListener(this.onViewportChangeHandler);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);

      if (this.viewportMediaQuery) {
        if (typeof this.viewportMediaQuery.removeEventListener === 'function') {
          this.viewportMediaQuery.removeEventListener('change', this.onViewportChangeHandler);
        } else if (typeof this.viewportMediaQuery.removeListener === 'function') {
          this.viewportMediaQuery.removeListener(this.onViewportChangeHandler);
        }
      }

      if (this.headerObserver) {
        this.headerObserver.disconnect();
        this.headerObserver = null;
      }

      if (this.isScrolling) {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = null;
      }
    }

    setHeaderHeight() {
      if (!this.header) return;

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    createObserver() {
      if (!this.header || typeof IntersectionObserver === 'undefined') {
        this.updateHeaderBounds();
        return;
      }

      this.headerObserver = new IntersectionObserver((entries, observer) => {
        const entry = entries && entries[0];

        if (entry) {
          this.headerBounds = entry.intersectionRect;
        } else {
          this.updateHeaderBounds();
        }

        observer.disconnect();
        this.headerObserver = null;
      });

      this.headerObserver.observe(this.header);
    }

    updateHeaderBounds() {
      if (!this.header) return;

      const rect = this.header.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

      this.headerBounds = {
        top: rect.top + scrollTop,
        bottom: rect.bottom + scrollTop
      };
    }

    onScroll() {
      if (!this.header) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const headerBottom = Number.isFinite(this.headerBounds.bottom)
        ? this.headerBounds.bottom
        : 0;
      const headerTop = Number.isFinite(this.headerBounds.top)
        ? this.headerBounds.top
        : 0;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventHide) {
          requestAnimationFrame(() => this.hide());
        }
      } else if (scrollTop < this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(() => this.reveal());
        } else {
          if (this.isScrolling) {
            window.clearTimeout(this.isScrolling);
          }

          this.isScrolling = window.setTimeout(() => {
            this.preventReveal = false;
            this.isScrolling = null;
          }, 66);

          requestAnimationFrame(() => this.hide());
        }
      } else if (scrollTop <= headerTop) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(() => this.reset());
      }

      this.currentScrollTop = Math.max(scrollTop, 0);
    }

    hide() {
      if (!this.header || this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (!this.header || this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (!this.header || this.headerIsAlwaysSticky) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      if (!this.header) return;

      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');

      this.disclosures.forEach((disclosure) => {
        if (disclosure && typeof disclosure.close === 'function') {
          disclosure.close();
          return;
        }

        const details = disclosure && disclosure.querySelector('details');
        if (details) details.removeAttribute('open');
      });
    }

    closeSearchModal() {
      if (!this.header) return;

      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      if (!this.searchModal) return;

      if (typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
        return;
      }

      const details = this.searchModal.querySelector('details');
      if (details) details.removeAttribute('open');
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
